import script from "./multi-file-direct-uploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-file-direct-uploader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__